export default __webpack_public_path__ + "static/media/off.deebec03.svg";